<template>

    <div class="layout__padding-clear layout__width-70 text__align-center">
        <div class="layout__margin-60-0 layout__overflow-hidden">

            <img class="layout__padding-20-0 layout__width-200px"
                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/lawrenceRand/Lr-Square-Master-white-300x300.png">

            <p class="text__colour-white layout__padding-20-0">Design Studio</p>

            <div class="text__size-36 text__colour-white">Lawrence Rand</div>

            <hr>

            <p class="text__line-height-30px text__colour-white">
                A rebrand which served two purposes: one, to create a brand with consistent marketing collateral; the
                other, to attract the highest quality of employees as well as retain them. The client wanted a brand to
                be proud of that stood out locally as a beacon of customer service and quality. It’s all about
                chemistry…
            </p>

            <hr>

            <el-button class="button-red layout__width-200px"
                       v-on:click="showcase()">Back to our work
            </el-button>


            <div class="layout__overflow-hidden layout__margin-40-0">
                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/lawrenceRand/Lawrence-Rand-case-study-.jpg">

                <div class="layout__padding-20-0 text__size-30 text__colour-white">
                    <span class="text__colour-a6667b">Chemistry </span>is a simple emotion that people feel when they share a <span class="text__colour-a6667b">special connection</span>. It forms the
                    basis of everything Lawrence Rand stands for…

                </div>

                <p class="text__colour-white layout__padding-20-0">Project Brief</p>

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/lawrenceRand/Lawrence-Rand-case-study-3.jpg">

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/lawrenceRand/Lawrence-Rand-case-study-4.jpg">

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/lawrenceRand/Lawrence-Rand-case-study-5.jpg">

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/lawrenceRand/Lawrence-Rand-case-study-6.jpg">

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/lawrenceRand/Lawrence-Rand-case-study-7.jpg">
            </div>


        </div>
    </div>

</template>

<script>
    import Router from '../../../router';
    import {Carousel, Slide} from 'vue-carousel';

    export default {
        name: "landnewhomes",
        props: {},
        components: {
            Carousel,
            Slide
        },
        mixins: [],
        data() {
            return {}
        },
        created() {
        },
        methods: {
            contactUs() {
                Router.push({
                    name: '/contact'
                });
            },
            print() {
                Router.push({
                    name: '/products/print'
                });
            },
            digital() {
                Router.push({
                    name: '/products/print'
                });
            },
            showcase(page) {
                Router.push({
                    name: '/services/design-studio/our-work',
                    query: {
                        client: page,
                    }
                });
            }
        },
    };
</script>